module.exports = __webpack_public_path__ + "static/img/game-FenyxRising_PC.2bbcbf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-FenyxRising_PC.jpg
// module id = BOJ/
// module chunks = 0